/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharecardtitle2Inputs */

const en_sharecardtitle2 = /** @type {(inputs: Sharecardtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share & collect credits`)
};

const de_sharecardtitle2 = /** @type {(inputs: Sharecardtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen & Credits sammeln`)
};

/**
* | output |
* | --- |
* | "Share & collect credits" |
*
* @param {Sharecardtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharecardtitle2 = /** @type {((inputs?: Sharecardtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharecardtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharecardtitle2(inputs)
	return de_sharecardtitle2(inputs)
});
export { sharecardtitle2 as "shareCardTitle" }